export class ContextMenuManager {
    setContextMenu;
    registerSetState(setContextMenu) {
        this.setContextMenu = setContextMenu;
    }
    showContextMenu(props) {
        if (!this.setContextMenu) {
            console.error('[ContextMenuManager] Tried to show a context menu without a registered `setState`.');
            return undefined;
        }
        this.setContextMenu(props);
    }
    hideContextMenu() {
        if (!this.setContextMenu) {
            return;
        }
        this.setContextMenu(null);
    }
}
const contextMenuManager = new ContextMenuManager();
export default contextMenuManager;
//# sourceMappingURL=ContextMenuManager.js.map